import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import Container from "./container";
const WithoutStickyHeader = forwardRef(function WithoutStickyHeader({ renderWrapper, header, content, close }, ref) {
    return (_jsx(Container, { ref: ref, children: renderWrapper({
            children: (_jsxs(_Fragment, { children: [close, header, content] })),
        }) }));
});
export default WithoutStickyHeader;
